import { useContext } from "react";
import DepositModalContext from "../store/DepositModalContext";
import DepositModalBox from "./DepositModalBox";
const DipositModal = () => {
  const { isDepositModalOpen, hideModal, showModal } =
    useContext(DepositModalContext);
  return (
    <>
      {isDepositModalOpen && (
        <DepositModalBox handleClose={hideModal} handleOpen={showModal} />
      )}
    </>
  );
};
export default DipositModal;
